import {
    Component,
    Input,
    OnInit,
    AfterContentInit,
    ElementRef,
    EventEmitter,
    ViewChild,
    Renderer2,
    Output,
    NgZone,
    OnDestroy,
    inject, OnChanges, SimpleChanges
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {Subscription} from "rxjs";
import {ScrollbarHelper, DimensionsHelper, ColumnChangesService} from "@swimlane/ngx-datatable";
import {TooltipDirective} from 'ngx-bootstrap/tooltip';
import { PageNotificationService, GadgetApiService, ShareDataService, EventBusService } from '@signature-it/ngx-generic/services';
import {EventData, EventName} from "@signature-it/ngx-generic/classes";
import {DTPage} from '@signature-it/ngx-generic/models';
import { GenericConfig } from '@signature-it/ngx-generic/config';
import {TranslateService} from "@ngx-translate/core";
declare let _: any;

@Component({
    selector: 'grid-gadget',
    templateUrl: './grid.gadget.html',
    styleUrls: ['./grid.gadget.scss'],
    providers: [ScrollbarHelper, DimensionsHelper, ColumnChangesService],
    standalone: false
})
export class GridGadget implements OnInit, AfterContentInit, OnDestroy, OnChanges {
    @Input() title: string;
    @Input() subTitle: string;
    @Input() breakLength: number;
    @Input() breakLengthMobile: number;
    @Input() btnText: string;
    @Input() btnLink: string;
    @Input() colors: string[];
    @Input() textColors: string[];
    @Input() border: string[];
    @Input() key: string;
    @Input() numOfColForTableViewMobile: number;
    @Input() dataConfig: Array<any> = [];
    @Input() url: string;
    @Input() count: number = 0;
    @Input() attributes: any = {};
    @Input() solrAttributes: any = {};
    @Input() paginationPosition: string = 'top';
    @Input() dependSelector: any = '';
    @Input() line:number;
    @Input() productId: string = null;

    data: any = {};
    previousRow: any = null;

    columns: Array<any> = [];
    /** Table Variables **/
    dtLineTable = {
        loading: false,
        page: new DTPage(),
        messages: {}
    };
    dataTable = [];
    fullDataTable = [];
    dataTableConfig = {};
    filtersField:any = [];
    dataFooter = [];
    gridId: string;
    footerHeight = 0;
    rowClass: Array<any> = [];
    tooltipData: string;
    page = {
        pageNumber:0,
        size: undefined, // Unlimited
        totalElements: 0
    };
    externalPaging: any;
    subscriptionsList$: Array<Subscription> = [];
    eventBusService: EventBusService;

    @Input() readMoreType: string = 'text';
    @ViewChild('gridTable') table: any;
    @ViewChild('gridToolTip') gridToolTip: TooltipDirective;
    @Output() isGridData: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        protected notifySvc: PageNotificationService,
        public router: Router,
        private route: ActivatedRoute,
        protected gadgetApiSvc: GadgetApiService,
        protected element: ElementRef,
        public shareSvc: ShareDataService,
        protected renderer: Renderer2,
        protected ngZone: NgZone,
        protected translateSvc: TranslateService,
        ) {
        this.eventBusService = inject(EventBusService);
    }

    ngOnInit() {
        if (this.dataConfig.length == 0 && GenericConfig.gadgets) {
            let gadget = GenericConfig.gadgets.find(g=>g.key === this.key)
            if (gadget) {
                this.title = this.title || gadget.title;
                this.subTitle = this.subTitle || gadget.subTitle;
                this.gridId = this.title;
                this.btnText = this.btnText || gadget.btnText;
                this.btnLink = this.btnLink || gadget.btnLink;
                this.colors = this.colors || gadget.colors;
                this.border = this.border || gadget.border;
                this.textColors = this.textColors || gadget.textColors;
                this.numOfColForTableViewMobile = this.numOfColForTableViewMobile || gadget.numOfColForTableViewMobile;
                this.url = this.url || gadget.url;
                this.attributes = this.attributes || gadget.attributes;
                this.dataConfig = gadget.data;
                this.breakLengthMobile = this.breakLengthMobile || gadget.breakLengthMobile;

                if(this.shareSvc.isMobileMode()){
                    this.breakLength = this.breakLengthMobile;
                }else{
                    this.breakLength = this.breakLength || gadget.breakLength;
                }
                this.count = this.count || gadget.count;
            }

        }
        this.shareSvc.hideDependElements(this.attributes['depend-selector']);
        this.gridId = this.title.replace(/ /g, '-');
        if (this.colors) {
            this.data.colors = this.colors;
        }
        if (this.textColors) {
            this.data.textColors = this.textColors;
        }
        this.getData(0);

    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.productId && !changes.productId.isFirstChange()) {
            this.getData(0);
        }
    }
    ngAfterContentInit() {
    }

    ngAfterViewChecked() {
        this.ngZone.runOutsideAngular(() => {
            setTimeout(() => {
                if (this.shareSvc.isMobileMode() && this.table && this.table.rowDetail && !this.count) {
                    this.table.rowDetail.expandAllRows();
                }
            }, 0)
        })

    }

    getData(pageInfo) {
        let pid;
        let sb$
        if (this.productId){
            sb$ = this.initGridData(this.productId, pageInfo);
        } else {
            sb$ = this.route.params.subscribe(
            data => {
                if (data) {
                    pid = data.id
                }
                this.initGridData(pid, pageInfo);
            });
        }
        this.subscriptionsList$.push(sb$);
    }

    initGridData(pid, pageInfo) {
        let page = _.has(pageInfo, 'offset') ? pageInfo.offset + 1 : pageInfo;
        this.attributes.pageNumber = page;
        this.columns = [];
        this.fullDataTable = [];
        this.gadgetApiSvc.getGridData(pid, this.key, this.url, this.attributes, this.solrAttributes)
            .subscribe(
                res => {
                    if (res && res.data.length) {
                        this.shareSvc.showDependElements(this.attributes['depend-selector']);
                        this.dataTable = res.data;
                        this.fullDataTable = res.data;
                        if ( !_.isEmpty(res.footer) ) {
                            this.dataFooter = res.footer;
                            this.footerHeight = 50;
                        }
                        const self = this;
                        if (this.dataConfig) {
                            this.rowClass = this.dataConfig.filter(rowclass => this.isClass(rowclass.isClass)).map(function(rowclass) { return rowclass.field; });
                            let breakLengthDataConfig = _.sortBy(this.dataConfig, 'breakLength');
                            breakLengthDataConfig.forEach(function (item) {
                                self.dataTable.forEach(function (product){
                                    product[item.field + '_short'] = self.truncateChar(item.breakLength, product[item.field] ? self.translateSvc.instant(product[item.field]) : '');
                                    product[item.field + '_char'] = self.getCharFromHtml(product[item.field] ? self.translateSvc.instant(product[item.field]) : '');
                                });
                            });
                            let sortDataConfig = _.sortBy(this.dataConfig, 'order');
                            self.filtersField = [];
                            sortDataConfig.forEach(function (item) {
                                if(item.filter){
                                    var filterN = [];
                                    var filtered = _.uniq((res.data).map(t=>t[item.field]));
                                    filtered.forEach(function (c,i) {
                                        filterN.push({'name':c,'checked':true});
                                    });
                                    let v = {};
                                    v['key'] = item.field;
                                    v['value'] = filterN;
                                    self.filtersField.push(v);
                                }
                            if(item.visible != 'none') {
                                self.columns.push({name: item.field});
                                self.dataTableConfig[item.field] = item;
                                }
                            });
                        }
                        else {
                            self.dataTableConfig = {};
                            Object.keys(this.dataTable[0]).forEach(function (item) {
                                self.columns.push({name: item});
                                self.dataTableConfig[item] = {alias: item};
                            });
                        }
                        this.count = this.shareSvc.isMobileMode() ? this.count : this.columns.length;

                        setTimeout(()=> {
                            // let ele =  this.element.nativeElement;
                            // this.renderer.setAttribute(ele.getElementsByClassName('datatable-header')[0], 'background-color', this.colors[0]);
                            let currentTable = document.getElementById(this.gridId);
                            if(currentTable){
                                var ele = document.getElementById(this.gridId).getElementsByClassName('datatable-row-wrapper');
                                for (var i = 0; i < ele.length; i++ ) {
                                    ele[i].setAttribute("role","row");
                                }
                               document.getElementById(this.gridId).getElementsByClassName('datatable-body')[0].setAttribute("role","rowgroup");
                               document.getElementById(this.gridId).getElementsByClassName('datatable-header')[0].setAttribute("role","rowgroup");
                               document.getElementById(this.gridId).getElementsByClassName('datatable-row-center')[0].setAttribute("role","row");
                                var ele = document.getElementById(this.gridId).getElementsByClassName('datatable-header-cell');
                                for (var i = 0; i < ele.length; i++ ) {
                                    ele[i].setAttribute("role","columnheader");
                                }
                                var ele = document.getElementById(this.gridId).getElementsByClassName('datatable-body-cell');
                                for (var i = 0; i < ele.length; i++ ) {
                                    ele[i].setAttribute("role","cell");
                                }
                            }
                            if (this.colors[0] && currentTable)
                                document.getElementById(this.gridId).getElementsByClassName('datatable-header')[0]['style'].backgroundColor = this.colors[0];
                            if (this.colors[1] && currentTable && document.getElementById(this.gridId).getElementsByClassName('datatable-footer').length)
                                document.getElementById(this.gridId).getElementsByClassName('datatable-footer')[0]['style'].backgroundColor = this.colors[1];
                            if(currentTable && !this.shareSvc.isMobileMode()) {
                                var ele = document.getElementById(this.gridId).getElementsByClassName('datatable-row-even');
                                if (this.colors[2] && currentTable && ele.length){
                                    for (var i = 0; i < ele.length; i++ ) {
                                        ele[i]['style'].backgroundColor = this.colors[2];
                                    }
                                }
                                var ele = document.getElementById(this.gridId).getElementsByClassName('datatable-row-odd');
                                if (this.colors[3] && currentTable && ele.length){
                                    if (this.colors[2] && currentTable && ele.length){
                                        for (var i = 0; i < ele.length; i++ ) {
                                            ele[i]['style'].backgroundColor = this.colors[3];
                                        }
                                    }
                                }
                            }else{
                                if (this.colors[2] && currentTable) {
                                    var ele = document.getElementById(this.gridId).getElementsByClassName('datatable-row-even');
                                    for (var i = 0; i < ele.length; i++ ) {
                                        ele[i]['style'].backgroundColor = this.colors[2];
                                    }
                                    var ele = document.getElementById(this.gridId).getElementsByClassName('datatable-row-odd');
                                    for (var i = 0; i < ele.length; i++ ) {
                                        ele[i]['style'].backgroundColor = this.colors[2];
                                    }
                                }
                            }
                            if (this.textColors) {
                                if (this.textColors[0] && currentTable)
                                    document.getElementById(this.gridId).getElementsByClassName('datatable-header')[0]['style'].color = this.textColors[0];
                                if (this.textColors[1] && currentTable)
                                    document.getElementById(this.gridId).getElementsByClassName('datatable-footer')[0]['style'].color = this.textColors[1]
                            }
                            if(this.border && currentTable){
                                if (this.border[0]) {
                                    document.getElementById(this.gridId).getElementsByClassName('datatable-header')[0]['style'].borderBottom = '1px solid';
                                    document.getElementById(this.gridId).getElementsByClassName('datatable-header')[0]['style'].borderBottomColor = this.border[0];
                                }
                                if (this.border[1]) {
                                    let rows = document.getElementById(this.gridId).getElementsByClassName('datatable-body-row');
                                    for (let i = 0; i < rows.length; i++) {
                                        rows[i]['style'].borderBottom = '1px solid';
                                        rows[i]['style'].borderBottomColor = this.border[1];
                                    }
                                }
                            }
                            if (res.numFound && this.paginationPosition === 'top') {
                                if (currentTable) {
                                    let width = document.getElementById(this.gridId).getElementsByClassName('datatable-scroll')[0]['style'].width;
                                    document.getElementById(this.gridId).getElementsByClassName('datatable-footer')[0]['style'].position = 'absolute';
                                    document.getElementById(this.gridId).getElementsByClassName('datatable-footer')[0]['style'].top = 0;
                                    document.getElementById(this.gridId).getElementsByClassName('datatable-footer')[0]['style'].border = 'none';
                                    document.getElementById(this.gridId).getElementsByClassName('datatable-footer')[0]['style'].width = width;
                                    document.getElementById(this.gridId).getElementsByClassName('datatable-header')[0]['style'].position = 'absolute';
                                    document.getElementById(this.gridId).getElementsByClassName('datatable-header')[0]['style'].top = '50px';
                                    document.getElementById(this.gridId).getElementsByClassName('datatable-header')[0]['style'].width = width;
                                    document.getElementById(this.gridId).getElementsByClassName('datatable-body')[0]['style'].marginTop = '100px';
                                    document.getElementById(this.gridId).getElementsByClassName('ngx-datatable')[0]['style'].border = 'none';
                                }
                            }
                            if (this.line) {
                                this.shortenText();
                            }
                        }, 100);
                        this.isGridData.emit([{'key' :this.key, 'data': true}]);
                        if (res.numFound) {
                            this.page = {
                                pageNumber: _.has(pageInfo, 'offset') ? pageInfo.offset : pageInfo,
                                size: this.attributes.size,
                                totalElements: res.numFound
                            };
                            this.footerHeight = 50;
                            this.externalPaging = this.attributes['external-paging'];
                        }
                    } else {
                        this.isGridData.emit([{'key' :this.key, 'data': false}]);
                        // this.notifySvc.set('Some Error Occurred').show();
                    }
                },
                error => {
                    this.notifySvc.set(error).show();
                }
            );
    }

    getRowClass = (row) => {
        let classes: { [id: string]: any; } = {};
        this.rowClass.forEach(function (c) {
            classes[row[c]] = true;
        });
        return classes;
    }

    isClass(_class){
        return _class == 1;
    }

    filterData(key,val,filter1){
        let fields = filter1.filter(function( f ) {
            return f.checked == true;
        });
        this.dataTable = this.fullDataTable.filter(function( obj ) {
            return fields.some(function(el) {
                return el.name === obj[key];
            });
        });
        this.eventBusService.emit(new EventData(`${EventName.GRID_GADGET_FILTER_CHANGE}`, {key: this.key, fields}));
    }


    toggleExpandRow(e, row) {
        let datatableRowWrapper = e.currentTarget.parentElement.parentElement.parentElement.parentElement.parentElement;
        datatableRowWrapper.ariaExpanded = datatableRowWrapper.ariaExpanded === 'true'? 'false': 'true';
        if(this.line && this.shareSvc.isMobileMode() && datatableRowWrapper.ariaExpanded ==='true') {
            this.ngZone.runOutsideAngular(() => {
                setTimeout(() => {
                    this.shortenText();
                }, 0)
            })
        }
        this.table.rowDetail.toggleExpandRow(row);
    }

    truncateChar(breakLength,text: string): string {
        if(this.shareSvc.isMobileMode()){
            this.breakLength = this.breakLengthMobile;
        }else{
            this.breakLength = breakLength;
        }
        if(!text || !this.breakLength || text.length <= this.breakLength )
        {
            return text;
        }
        let without_html = this.getCharFromHtml(text);
        let shortened = without_html.substring(0, this.breakLength) + "...";
        return shortened;
    }

    getCharFromHtml(text){
        if(!text) return '';
        let without_html = text.replace(/<(?:.|\n)*?>/gm, '');
        without_html = without_html.replace(/\n/g, '');
        without_html = without_html.replace(/\s\s/g, '');
        return without_html;
    }

    setTooltipData(data: any) {
        if (!data) return;
        this.tooltipData = data;
        this.setTooltipMargin();
    }

    setTooltipMargin() {
        setTimeout(function(){
            let el = document.getElementsByClassName('bs-tooltip-top')[0];
            if (el) {
                try {
                    let height = document.getElementsByClassName('bs-tooltip-top')[0].getBoundingClientRect().height;
                    document.getElementsByClassName('bs-tooltip-top')[0]['style'].marginTop = '-' + height + 'px';
                } catch (e) {
                    return;
                }
            } else {
                this.setTooltipMargin();
            }
        }, 0);
    }

    getFieldData(row, conf, breakLength, index, checkType = true) {
        let self = this;
        let html, str;
        if (checkType) {
            if (conf.type == 'download') {
                str = self.getFieldData(row, conf, breakLength, index, false);
                return `<a class="document_download" href="${str}"><i class="fa fa-download"></i><span >${this.translateSvc.instant('Download document')}</span></a>`
            }
        }
        if (conf.children) {
            html = '<div>';
            conf['children'].forEach(function (child) {
                str = self.getFieldData(row, child, breakLength, index);
                if (str) {
                    html += '<div>';
                    if (child['alias']) html += '<strong>' + child['alias'] + ': </strong>'
                    html += '<span>' + str + '</span>'
                    html += '</div>'
                }
            });
            html += '</div>'
            return html;
        }
        if (typeof conf['field'] == 'string') {
            let value = breakLength && !row['showAllText'+index] && !this.line ? row[conf['field'] + '_short'] : row[conf['field']];
            return value ? this.translateSvc.instant(value) : '';
        } else {
            let values = [];
            conf['field'].forEach(function (f) {
                if(row[f]) values.push(row[f]);
            });
            return values.join(conf.separator);
        }
    }

    shortenText() {
        this.table?.element?.querySelectorAll('.ellipsis').forEach(e => {
            let divHeight = (e as HTMLElement).offsetHeight,
                lineHeight = (e as HTMLElement).style.lineHeight;
            if (!lineHeight) {
                lineHeight = window.getComputedStyle(e, null).lineHeight;
            }
            /*
            * calculate the height of the text container and truncate the text when it exceeds a certain height
            * */
            this.line < divHeight / parseInt(lineHeight, 10) ?
                (e as HTMLElement).style['height'] = this.calcHeight(lineHeight, false):
                e.classList.add('short-text');
        })
    }
      /*
       *  @param line-height of the element, isOpen / not , (number of lines)
       *  @return truncate text when it exceeds a certain number of lines
      * */
    calcHeight(lineH, isOpen){
        let height;
        let style = ((parseInt(lineH, 10)) * this.line);
        height = isOpen ? 'auto' : style+"px";
        return height;
    }

    toggleOpen(elementEvent, row, index) {
        row['showAllText'+index] = !row['showAllText'+index];
        let extractInfoEvent = elementEvent.currentTarget.parentElement.children[0];
        let lineH = ((extractInfoEvent as HTMLElement).style.lineHeight) ? ((extractInfoEvent as HTMLElement).style.lineHeight) : "25px" ;
        (extractInfoEvent as HTMLElement).style['height'] = this.calcHeight(lineH, row['showAllText'+index]);
    }


    ngOnDestroy(): void {
        if (this.subscriptionsList$ && this.subscriptionsList$.length) {
            this.subscriptionsList$.forEach(s => s.unsubscribe());
        }
    }
}
